module.exports = __webpack_public_path__ + "img/08 Aniamtion 3-squashed.23018c7b.jpg";